import React, { useState } from "react";
import { Row, Col, Card, Typography, Button } from "antd";
import {
    PlusOutlined,
    SettingOutlined,
    BookOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";

import TodoList from "../NewDashboard/CalenderAndTodo/TodoList";
import CalendarViewAndTransaction from "../NewDashboard/CalenderAndTodo/CalendarViewAndTransaction";
import SubjectFormModal from "../SchoolDashApp/Class/Subjects/SubjectFormModal";
import ProfileImageDashboard from "../NewDashboard/ProfileImageDashboard";
import TotalStudentsCard from "../NewDashboard/pages/TotalStudentsCard";
import AcademicCount from "../NewDashboard/pages/AcademicCount";

const { Title, Text } = Typography;

const TeacherOverview = ({ theme }) => {
    const [openSubjectModal, setOpenSubjectModal] = useState(false);

    const triggerAcademicCountUpdate = () => {
        window.dispatchEvent(new Event("academicCountUpdated"));
    };

    return (
        <div
            className="teacher-overview-page"
            style={{
                width: "100%",
                maxWidth: 1800,
                margin: "0 auto",
                padding: "0 2px",
                boxSizing: "border-box",
                overflow: "hidden",
            }}
        >
            <motion.div
                initial={{ opacity: 0, y: 7 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
            >
                <Card
                    bordered={false}
                    className="teacher-overview-main-card"
                    style={{
                        width: "100%",
                        marginBottom: 16,
                        borderRadius: 18,
                        overflow: "hidden",
                        background: theme.card,
                        border: `1px solid ${theme.border}`,
                        boxShadow:
                            "0 8px 26px rgba(6,42,75,.055)",
                    }}
                    styles={{
                        body: {
                            padding: 0,
                        },
                    }}
                >
                    <div className="teacher-overview-header">
                        <div className="teacher-overview-header-decoration" />

                        <div className="teacher-overview-header-left">
                            <div className="teacher-overview-profile">
                                <ProfileImageDashboard
                                    theme={theme}
                                    overview
                                />
                            </div>

                            <div className="teacher-overview-header-divider" />

                            <div className="teacher-overview-heading">
                                <Text
                                    className="teacher-overview-eyebrow"
                                    style={{
                                        color: theme.secondary,
                                    }}
                                >
                                    Teaching Workspace
                                </Text>

                                <Title
                                    level={3}
                                    className="teacher-overview-title"
                                    style={{
                                        color: theme.text,
                                    }}
                                >
                                    Teacher Overview
                                </Title>
                            </div>
                        </div>

                        <div className="teacher-overview-header-actions">
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                className="teacher-overview-add-button"
                                onClick={() =>
                                    setOpenSubjectModal(true)
                                }
                            >
                                <span className="teacher-overview-add-label">
                                    Add Course
                                </span>
                            </Button>
                        </div>
                    </div>
                </Card>

                <Row
                    gutter={[14, 14]}
                    style={{
                        width: "100%",
                        margin: 0,
                    }}
                >
                    <Col
                        xs={24}
                        sm={12}
                        xl={12}
                        style={{
                            paddingLeft: 7,
                            paddingRight: 7,
                        }}
                    >
                        <TotalStudentsCard theme={theme} />
                    </Col>

                    <Col
                        xs={24}
                        sm={12}
                        xl={12}
                        style={{
                            paddingLeft: 7,
                            paddingRight: 7,
                        }}
                    >
                        <AcademicCount theme={theme} />
                    </Col>
                </Row>

                <Row
                    gutter={[14, 14]}
                    style={{
                        marginTop: 14,
                        marginLeft: 0,
                        marginRight: 0,
                    }}
                >
                    <Col xs={24} xl={11}>
                        <motion.div
                            initial={{ opacity: 0, y: 8 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.08,
                                duration: 0.3,
                            }}
                            style={{
                                height: "100%",
                            }}
                        >
                            <Card
                                bordered={false}
                                style={{
                                    height: "100%",
                                    minHeight: 350,
                                    borderRadius: 18,
                                    background: theme.card,
                                    border: `1px solid ${theme.border}`,
                                    boxShadow:
                                        "0 8px 26px rgba(6,42,75,.055)",
                                    overflow: "hidden",
                                }}
                                styles={{
                                    body: {
                                        padding: 0,
                                    },
                                }}
                            >
                                <div
                                    className="teacher-overview-section-header"
                                    style={{
                                        borderBottom: `1px solid ${theme.border}`,
                                    }}
                                >
                                    <div
                                        className="teacher-overview-section-title-area"
                                        style={{
                                            minWidth: 0,
                                        }}
                                    >
                                        <Text
                                            style={{
                                                display: "block",
                                                color: theme.secondary,
                                                fontSize: 10,
                                                lineHeight: 1.1,
                                                fontWeight: 700,
                                                letterSpacing: ".8px",
                                                textTransform: "uppercase",
                                            }}
                                        >
                                            Daily Workspace
                                        </Text>

                                        <Title
                                            level={4}
                                            style={{
                                                margin: "3px 0 0",
                                                color: theme.text,
                                                fontSize: 18,
                                                lineHeight: 1.2,
                                                fontWeight: 800,
                                            }}
                                        >
                                            Tasks & Priorities
                                        </Title>
                                    </div>

                                    <div
                                        className="teacher-overview-section-icon"
                                        style={{
                                            background:
                                                theme.mode === "dark"
                                                    ? "rgba(192,117,13,.12)"
                                                    : "#FCF8F1",
                                            color: "#C0750D",
                                        }}
                                    >
                                        <SettingOutlined />
                                    </div>
                                </div>

                                <div
                                    style={{
                                        padding: 12,
                                    }}
                                >
                                    <TodoList />
                                </div>
                            </Card>
                        </motion.div>
                    </Col>

                    <Col xs={24} xl={13}>
                        <motion.div
                            initial={{ opacity: 0, y: 8 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.12,
                                duration: 0.3,
                            }}
                            style={{
                                height: "100%",
                            }}
                        >
                            <Card
                                bordered={false}
                                style={{
                                    height: "100%",
                                    minHeight: 350,
                                    borderRadius: 18,
                                    background: theme.card,
                                    border: `1px solid ${theme.border}`,
                                    boxShadow:
                                        "0 8px 26px rgba(6,42,75,.055)",
                                    overflow: "hidden",
                                }}
                                styles={{
                                    body: {
                                        padding: 0,
                                    },
                                }}
                            >
                                <div
                                    className="teacher-overview-section-header"
                                    style={{
                                        borderBottom: `1px solid ${theme.border}`,
                                    }}
                                >
                                    <div
                                        className="teacher-overview-section-title-area"
                                        style={{
                                            minWidth: 0,
                                        }}
                                    >
                                        <Text
                                            style={{
                                                display: "block",
                                                color: theme.secondary,
                                                fontSize: 10,
                                                lineHeight: 1.1,
                                                fontWeight: 700,
                                                letterSpacing: ".8px",
                                                textTransform: "uppercase",
                                            }}
                                        >
                                            Teaching Activity
                                        </Text>

                                        <Title
                                            level={4}
                                            style={{
                                                margin: "3px 0 0",
                                                color: theme.text,
                                                fontSize: 18,
                                                lineHeight: 1.2,
                                                fontWeight: 800,
                                            }}
                                        >
                                            Calendar & Transactions
                                        </Title>
                                    </div>

                                    <div
                                        className="teacher-overview-section-icon"
                                        style={{
                                            background:
                                                theme.mode === "dark"
                                                    ? "rgba(15,109,171,.12)"
                                                    : "#F3F8FC",
                                            color: "#0F6DAB",
                                        }}
                                    >
                                        <BookOutlined />
                                    </div>
                                </div>

                                <div
                                    style={{
                                        padding: 12,
                                    }}
                                >
                                    <CalendarViewAndTransaction />
                                </div>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>
            </motion.div>

            <SubjectFormModal
                open={openSubjectModal}
                handleClose={() => setOpenSubjectModal(false)}
                onSubjectCreated={triggerAcademicCountUpdate}
            />

            <style>
                {`
                    .teacher-overview-header {
                        position: relative;
                        width: 100%;
                        min-height: 82px;
                        padding: 12px 16px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 18px;
                        box-sizing: border-box;
                        overflow: hidden;
                    }

                    .teacher-overview-header-decoration {
                        position: absolute;
                        width: 150px;
                        height: 150px;
                        border-radius: 50%;
                        right: -60px;
                        top: -80px;
                        background: rgba(192,117,13,.045);
                        pointer-events: none;
                    }

                    .teacher-overview-header-left {
                        position: relative;
                        z-index: 1;
                        min-width: 0;
                        flex: 1 1 auto;
                        display: flex;
                        align-items: center;
                        gap: 14px;
                    }

                    .teacher-overview-profile {
                        flex: 0 0 auto;
                        min-width: 0;
                        display: flex;
                        align-items: center;
                    }

                    .teacher-overview-header-divider {
                        width: 1px;
                        height: 46px;
                        flex: 0 0 1px;
                        background: ${theme.border};
                    }

                    .teacher-overview-heading {
                        min-width: 0;
                        flex: 1 1 auto;
                        overflow: hidden;
                    }

                    .teacher-overview-eyebrow {
                        display: block;
                        margin-bottom: 2px;
                        font-size: 10px;
                        line-height: 1.1;
                        font-weight: 700;
                        letter-spacing: 1px;
                        text-transform: uppercase;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .teacher-overview-title {
                        margin: 0 !important;
                        font-size: 21px !important;
                        line-height: 1.15 !important;
                        font-weight: 800 !important;
                        letter-spacing: -.3px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .teacher-overview-header-actions {
                        position: relative;
                        z-index: 3;
                        flex: 0 0 auto;
                        min-width: 0;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                    }

                    .teacher-overview-add-button {
                        height: 38px !important;
                        min-width: 112px !important;
                        padding: 0 14px !important;
                        border-radius: 10px !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        gap: 5px !important;
                        font-weight: 750 !important;
                        background: #C0750D !important;
                        border-color: #C0750D !important;
                        box-shadow: 0 5px 15px rgba(192,117,13,.16) !important;
                        white-space: nowrap !important;
                    }

                    .teacher-overview-add-button:hover,
                    .teacher-overview-add-button:focus {
                        background: #A86208 !important;
                        border-color: #A86208 !important;
                    }

                    .teacher-overview-section-header {
                        padding: 15px 17px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 10px;
                    }

                    .teacher-overview-section-icon {
                        width: 36px;
                        height: 36px;
                        flex: 0 0 36px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    @media (max-width: 1200px) {
                        .teacher-overview-header {
                            gap: 12px;
                        }

                        .teacher-overview-header-left {
                            gap: 11px;
                        }

                        .teacher-overview-title {
                            font-size: 20px !important;
                        }
                    }

                    @media (max-width: 1000px) {
                        .teacher-overview-header {
                            align-items: flex-start;
                            flex-direction: column;
                            gap: 12px;
                            padding: 14px;
                        }

                        .teacher-overview-header-left {
                            width: 100%;
                            flex: 0 0 auto;
                        }

                        .teacher-overview-heading {
                            max-width: none;
                        }

                        .teacher-overview-header-actions {
                            width: 100%;
                            flex: 0 0 auto;
                            justify-content: flex-end;
                        }
                    }

                    @media (max-width: 600px) {
                        .teacher-overview-header {
                            min-height: auto;
                            padding: 13px 12px;
                            gap: 12px;
                        }

                        .teacher-overview-header-left {
                            width: 100%;
                            gap: 9px;
                            align-items: flex-start;
                        }

                        .teacher-overview-header-divider {
                            height: 42px;
                            margin-top: 1px;
                        }

                        .teacher-overview-heading {
                            width: 100%;
                            min-width: 0;
                        }

                        .teacher-overview-eyebrow {
                            font-size: 9px;
                            letter-spacing: .75px;
                        }

                        .teacher-overview-title {
                            font-size: 18px !important;
                            line-height: 1.15 !important;
                        }

                        .teacher-overview-header-actions {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                        }

                        .teacher-overview-add-button {
                            min-width: 112px !important;
                            width: auto !important;
                            height: 38px !important;
                            padding: 0 12px !important;
                        }

                        .teacher-overview-section-header {
                            padding: 14px;
                        }
                    }

                    @media (max-width: 460px) {
                        .teacher-overview-header {
                            padding: 12px 10px;
                            gap: 10px;
                        }

                        .teacher-overview-header-left {
                            gap: 8px;
                        }

                        .teacher-overview-header-divider {
                            display: none;
                        }

                        .teacher-overview-title {
                            font-size: 17px !important;
                        }

                        .teacher-overview-add-button {
                            min-width: 105px !important;
                            padding: 0 10px !important;
                        }
                    }

                    @media (max-width: 360px) {
                        .teacher-overview-header {
                            padding: 10px 9px;
                        }

                        .teacher-overview-title {
                            font-size: 16px !important;
                        }

                        .teacher-overview-eyebrow {
                            font-size: 8px;
                        }

                        .teacher-overview-add-button {
                            min-width: 98px !important;
                            padding: 0 8px !important;
                        }

                        .teacher-overview-add-label {
                            font-size: 12px;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default TeacherOverview;